export const UTMParams = [
    'utm_source',
    'utm_medium',
    'utm_compaign',
    'utm_term',
    'utm_content'
];
